import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import {
  Btn,
  CustomCheckbox,
  CustomModal,
  CustomMultiSelect,
  ExcelModeloBuilder,
  ImportExcelFile,
} from '../../../../components'
import { tableCellCentered } from '../../../../assets/js/styles'
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'
import * as OcorrenciaHttp from '../../../../services/api/https/picking/ocorrencia.http'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'

export const MODELO_COLUNAS = [['Codigo Interno', 'Descricao', 'Associar Cliente', 'Ativo']]
const MODELO_FILENAME = 'ModeloImportacaoOcorrenciasEntrega.xlsx'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  IMPORT_OCCURRENCES: 'Importando ocorrências de entrega',
}

const INITIAL_STATE = {
  selectedEmpresas: [],
  ocorrencias: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

function ModalImportOcorrenciaEntrega({ dispatch, show, onModalClose, onImported }) {
  const [state, setState] = useState({ ...INITIAL_STATE })
  const [empresas] = useState(getEmpresas())

  useEffect(() => {
    if (show) setState({ ...INITIAL_STATE })
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.IMPORT_OCCURRENCES:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        importOcorrencias()
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  const importOcorrencias = () => {
    OcorrenciaHttp.importOcorrencias(
      state.selectedEmpresas.map(empresa => empresa.id),
      state.ocorrencias,
    )
      .then(message => {
        setState({ ...INITIAL_STATE })
        dispatch(showMessageBox(message, null))
        onImported()
      })
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: errorHandler(err),
        })),
      )
  }

  const onEmpresasChange = selectedEmpresas => {
    setState(prevState => ({ ...prevState, selectedEmpresas }))
  }

  const onFileImported = content => {
    try {
      const ocorrencias = buildOcorrencias(content)
      setState(prevState => ({ ...prevState, ocorrencias }))
    } catch (error) {
      setState(prevState => ({ ...prevState, ocorrencias: [], errorMessage: error.message }))
    }
  }

  const onBtnSalvarClicked = () => {
    if (state.selectedEmpresas.length === 0)
      return setState(prevState => ({
        ...prevState,
        errorMessage: 'Selecione ao menos uma empresa',
      }))

    if (state.ocorrencias.length === 0)
      return setState(prevState => ({
        ...prevState,
        errorMessage: 'Importe a planilha com as ocorrências antes de salvar',
      }))

    setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.IMPORT_OCCURRENCES }))
  }

  return (
    <CustomModal
      header="Importar Ocorrências de Entrega"
      isVisible={show}
      onClose={onModalClose}
      width={1000}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <ExcelModeloBuilder modeloColunas={MODELO_COLUNAS} filename={MODELO_FILENAME} />
          <span style={{ display: 'inline-block', marginLeft: 10, fontSize: '0.8rem' }}>
            Preencha o modelo com as colunas Codigo Interno, Descricao, Associar Cliente (0 ou 1) e
            Ativo (0 ou 1).
          </span>
        </div>

        <div className="p-col-12 p-md-6">
          <CustomMultiSelect
            label="Empresas"
            optionLabel="name"
            options={empresas}
            value={state.selectedEmpresas}
            onChange={onEmpresasChange}
            filterPlaceholder="Pesquisar empresa"
            appendTo={document.body}
          />
        </div>

        <div className="p-col-12" style={{ fontSize: '0.85rem' }}>
          {state.selectedEmpresas.length === 0 ? (
            <span style={{ color: '#D32F2F' }}>
              Nenhuma empresa selecionada. As ocorrências não serão cadastradas.
            </span>
          ) : (
            <span>
              <strong>{state.selectedEmpresas.length}</strong> empresa(s) considerada(s) para o
              cadastro das ocorrências:{' '}
              <strong>{state.selectedEmpresas.map(empresa => empresa.name).join(', ')}</strong>
            </span>
          )}
        </div>

        <div className="p-col-12">
          <ImportExcelFile label="Importar" hasIcon onFileImported={onFileImported} />
          <span style={{ display: 'inline-block', marginLeft: 10, fontSize: '0.85rem' }}>
            {state.ocorrencias.length > 0
              ? `${state.ocorrencias.length} ocorrência(s) importada(s) da planilha`
              : 'Nenhuma planilha importada'}
          </span>
        </div>

        <div className="p-col-12">
          <DataTable
            value={state.ocorrencias}
            paginator={state.ocorrencias.length > 10}
            rows={10}
            emptyMessage="Importe a planilha para visualizar as ocorrências"
          >
            <Column field="sigla" header="Sigla" style={tableCellCentered()} />
            <Column field="company_code" header="Código Interno" style={tableCellCentered()} />
            <Column field="descricao" header="Descrição" />
            <Column
              field="assoc_guilty_client"
              header="Assoc. Cliente"
              style={tableCellCentered()}
              body={ocorrencia => (
                <CustomCheckbox disabled checked={ocorrencia.assoc_guilty_client} />
              )}
            />
            <Column
              field="actived"
              header="Ativo"
              style={tableCellCentered()}
              body={ocorrencia => <CustomCheckbox disabled checked={ocorrencia.actived} />}
            />
          </DataTable>
        </div>

        <div className="p-col-12" style={{ paddingTop: 20 }}>
          <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}

// Helpers
function normalizeHeader(value) {
  return value === undefined || value === null
    ? ''
    : value
        .toString()
        .trim()
        .toUpperCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
}

function parseBooleanColumn(value, columnName, line) {
  if (value === undefined || value === null || value.toString().trim() === '') return false

  const parsedValue = value.toString().trim()
  if (parsedValue === '0') return false
  if (parsedValue === '1') return true

  throw new Error(`Linha ${line}: A coluna ${columnName} aceita apenas 0 ou 1`)
}

function buildOcorrencias(content) {
  const header = (content[0] || []).map(normalizeHeader)
  const modelo = MODELO_COLUNAS[0].map(normalizeHeader)

  const isPlanilhaNoPadrao = modelo.every((column, index) => header[index] === column)
  if (!isPlanilhaNoPadrao) throw new Error('Planilha Fora do Padrão. Baixe o Modelo e Verifique.')

  const rows = content
    .map((row, index) => ({ row, line: index + 1 }))
    .slice(1)
    .filter(
      ({ row }) =>
        Array.isArray(row) &&
        row.some(cell => cell !== undefined && cell !== null && cell.toString().trim() !== ''),
    )
  if (rows.length === 0) throw new Error('Não existem ocorrências na planilha importada')

  const ocorrencias = rows.map(({ row, line }) => {
    const company_code = row[0] === undefined || row[0] === null ? '' : row[0].toString().trim()
    const descricao = row[1] === undefined || row[1] === null ? '' : row[1].toString().trim()

    if (!company_code) throw new Error(`Linha ${line}: Código Interno não informado`)
    if (!descricao) throw new Error(`Linha ${line}: Descrição não informada`)

    return {
      sigla: company_code.toUpperCase(),
      company_code: company_code.toUpperCase(),
      descricao: descricao.toUpperCase(),
      assoc_guilty_client: parseBooleanColumn(row[2], 'Associar Cliente', line),
      actived: parseBooleanColumn(row[3], 'Ativo', line),
    }
  })

  const codigosDuplicados = getDuplicatedValues(ocorrencias.map(o => o.company_code))
  if (codigosDuplicados.length > 0)
    throw new Error(
      `Existem Códigos Internos DUPLICADOS na planilha: ${codigosDuplicados.join(', ')}`,
    )

  const descricoesDuplicadas = getDuplicatedValues(ocorrencias.map(o => o.descricao))
  if (descricoesDuplicadas.length > 0)
    throw new Error(`Existem Descrições DUPLICADAS na planilha: ${descricoesDuplicadas.join(', ')}`)

  return ocorrencias
}

function getDuplicatedValues(values) {
  const seen = new Set()
  const duplicated = new Set()

  values.forEach(value => (seen.has(value) ? duplicated.add(value) : seen.add(value)))

  return Array.from(duplicated)
}

export default connect()(ModalImportOcorrenciaEntrega)
